








































































import { Component, Vue, Prop } from 'vue-property-decorator'
import { Product, Discount } from '@/store/types'
import ProductItem from '@/components/ProductItem.vue'
import DiscountItem from '@/components/DiscountItem.vue'
import DeliveryItem from '@/components/DeliveryItem.vue'
import { Action, Getter } from 'vuex-class'
import smoothReflow from 'vue-smooth-reflow'
import config from '@/config'

@Component({
	mixins: [smoothReflow],
	components: {
		ProductItem,
		DiscountItem,
		DeliveryItem,
	},
})
export default class ProductList extends Vue {
	$refs!: {
		list: Vue,
		container: Element,
	}

	private readonly vat = config.vat
	private readonly currency = config.currency

	@Prop({ type: Array, default: Array }) readonly products!: Product
	@Prop({ type: Number }) shippingCost100!: number

	@Getter private readonly summaryPrice100!: number

	@Getter private readonly totalPrice100!: number

	@Getter private readonly vatPrice100!: number

	@Getter private readonly discount!: Discount
	@Getter private readonly promoCode!: string
	@Getter private readonly isDiscount!: boolean

	@Action private deleteDiscount!: () => void

	mounted() {
		this.$smoothReflow!([
			{
				el: this.$refs.container,
				transition: 'height 0.5s',
				hideOverflow: false,
			}, {
				el: this.$refs.list.$el,
				transition: 'height 0.5s',
				hideOverflow: false,
				transitionEvent: {
					propertyName: 'transform',
				},
			}, {
				el: 'img',
				transition: 'height: 0.5s',
			},
		])
	}

	onDelete(product: Product) {
		this.$emit('delete', product)
	}

	onDiscountDelete() {
		this.deleteDiscount()
	}
}
